import { createRoot } from "react-dom/client";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import App from "./App.tsx";
import { initAnalytics } from "./lib/analytics";
import { installGlobalErrorHandlers } from "./lib/logger";
import { installTranslateGuard } from "./lib/translateGuard";
import "./index.css";

installGlobalErrorHandlers();
installTranslateGuard();
polyfillCountryFlagEmojis();
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
